import React from "react"
import { Button, Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import { ConfirmationModalProps } from "../types/modal"

export const ConfirmationModal = (props: ConfirmationModalProps) => {

    return (
        <Modal
            centered
            show={true}
            onHide={props.onCancel}>
            <Modal.Body>
                {props.children}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant={"secondary"}
                    onClick={props.onCancel}>
                    <FormattedMessage
                        id="common.modal.confirm_modal.no"
                        defaultMessage="No"/>
                </Button>

                <Button
                    onClick={props.onConfirm}>
                    <FormattedMessage
                        id="common.modal.confirm_modal.yes"
                        defaultMessage="Yes"/>
                </Button>
            </Modal.Footer>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/common/modal/ConfirmationModal.tsx